import { Controller } from "@hotwired/stimulus"

// Play/pause for the LogoSuite marquee.
//
// The scrolling itself is a CSS keyframe; hover and focus-within pause it in
// CSS too. What the platform has nothing for is a button that stops it, and
// honouring prefers-reduced-motion by starting stopped: those are here.
// Focus inside the marquee removes the animation entirely (the "focused"
// class) so a keyboard user is not chasing a moving link.
export default class extends Controller {
  static targets = ["marquee", "button", "playIcon", "pauseIcon"]
  static values = { playing: Boolean }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.playingValue = false
    }

    this.marqueeTarget.addEventListener("focusin", this.focusIn)
    this.marqueeTarget.addEventListener("focusout", this.focusOut)
  }

  disconnect() {
    this.marqueeTarget.removeEventListener("focusin", this.focusIn)
    this.marqueeTarget.removeEventListener("focusout", this.focusOut)
  }

  toggle() {
    this.playingValue = !this.playingValue
  }

  playingValueChanged() {
    this.element.classList.toggle("LogoSuite__logobar--paused", !this.playingValue)
    this.pauseIconTarget.hidden = !this.playingValue
    this.playIconTarget.hidden = this.playingValue
    this.buttonTarget.setAttribute("aria-label", this.playingValue ? "Pause animation" : "Play animation")
  }

  focusIn = () => {
    this.marqueeTarget.classList.add("LogoSuite__logobar-marquee--focused")
  }

  focusOut = (event) => {
    if (this.marqueeTarget.contains(event.relatedTarget)) return

    this.marqueeTarget.classList.remove("LogoSuite__logobar-marquee--focused")
  }
}
